@use "../../styles/breakpoint.module.scss" as *;

.root {
    composes: listReset from "../../styles/utils.module.scss";
    composes: fontHB64 from "../../styles/typography.module.scss";
    grid-column: 1 / -1;
    display: flex;
    flex-wrap: wrap;
    gap: var(--spacer-24) calc(var(--spacer-24) + 12px + var(--spacer-24));
    align-items: center;
    justify-content: center;
    margin-bottom: 0.2lh;

    @media ($below-mobile) {
        flex-direction: column;
    }
}

.link {
    composes: base from "../Clickables/index.module.scss";
    position: relative;

    &[data-hovered] {
        color: var(--red);
    }

    &:not([data-first-of-line="true"])::before {
        content: "";
        position: absolute;
        background: var(--light-orange);
        width: 12px;
        height: 12px;
        top: calc(50% - 6px);
        right: calc(100% + var(--spacer-24));
        border-radius: var(--border-radius-full);
    }
}

.wrapper {
    composes: repeater from "../../styles/layout.module.scss";
    grid-column: content;
}

.title {
    composes: fontST24 from "../../styles/typography.module.scss";
    font-weight: 800;
    grid-column: content;
    text-align: center;
    justify-self: center;
    margin-bottom: var(--spacer-40);
    max-width: 90ch;
}
